"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nDefaultValues = void 0;
exports.i18nDefaultValues = {
    Adblock: {
        title: 'Кажется, вы используете блокировщик рекламы Adblock',
        subTitle: 'Пожалуйста, отключите его и попробуйте еще раз',
        labels: {
            update: 'Обновить',
        },
    },
};
